export default __webpack_public_path__ + "static/MarkSteele-9b84b0fd8e1466fe116d3fe15e12d2ca.png";